<template>
	<div>
		<div class="row">
			<div class="col-xl-12">
				<carbon-card title="CARBON FOOTPRINT"></carbon-card>
			</div>
		</div>

	</div>
</template>

<script>
import { CarbonCard } from '@/components/index';
export default {
	name: 'carbon-footprint',
	components: {
		CarbonCard
	}
}
</script>

<style scoped>

</style>
